import Auth from '@/api/services/auth'

const state = {
    isAuth: false,
    isInitialized: false,
    isDone: false
}

const getters ={
    isAuth(state) {
        return state.isAuth
    },

    isInitialized(state) {
        return state.isInitialized
    },

    isDone(state) {
        return state.isDone
    }
}

const mutations = {
    setIsAuth(state, isAuth) {
        state.isAuth = isAuth
    },

    setIsInitialized(state, isInitialized) {
        state.isInitialized = isInitialized
    },

    setIsDone(state, isDone) {
        state.isDone = isDone
    }
}

const actions = {
    login({ dispatch, commit }, credentials) {
        return Auth()
            .login(credentials)
            .then(async data => {
                console.log(data)
                if (data.data) {
                    Object.assign(data.data, { 
                        customerData: {
                            partCard1: credentials.partCard1,
                            partCard2: credentials.partCard2,
                            partCard3: credentials.partCard3
                        }
                    })

                    commit('apiCustomer/setCustomerData', data.data, { root: true })
                    commit('setIsAuth', true)

                    dispatch('consentsResolver/resolve', { 
                        consents: data.data.marketingConsents,
                        leaflet: data.data.paperBrochure
                    },
                    { root: true })
                }
            })
    },

    logout({ commit, dispatch }) {
        return Auth()
            .logout()
            .then(async () => {
                await dispatch('apiCampaign/clearCampaign', {}, { root: true })
                await dispatch('apiCampaign/resolveCampaign', {}, { root: true })
                
                dispatch('apiSample/clearSample', {}, { root: true })
                commit('apiCustomer/clearCustomerData', {}, { root: true })
                commit('consentsResolver/clear', {}, { root: true })
                commit('coupon/clear', {}, { root: true })
                dispatch('steps/clear', {}, { root: true })
                commit('setIsAuth', false)

                localStorage.setItem('isDone', null)
            })
    },

    init({ commit, dispatch }) {
        commit('setIsInitialized', true)
        dispatch('siteLoader/close', {}, { root: true })
    },

    setIsDone({ commit }, isDone) {
        commit('setIsDone', isDone)
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}